import Swal from 'sweetalert2';

function alertDelete(config: {title: string; text?: string; button?: string}, callback: () => void): boolean {
  if (!config) return false;

  Swal.fire({
    title: config.title,
    text: config.text,
    icon: 'warning',
    confirmButtonText: config.button || '删 除',
    showConfirmButton: true,
    showCancelButton: true,
    cancelButtonText: '取 消',
    customClass: {
      confirmButton: 'el-button el-button--danger',
      cancelButton: 'el-button el-button--default',
    },
    buttonsStyling: false,
  }).then((result) => {
    if (result.isConfirmed && callback) {
      callback();
    }
  });

  return false;
}

export default alertDelete;
